import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import type { FormValues } from '../../schema';

interface BasicInfoTabProps {
  formMode: 'add' | 'edit' | 'view';
  values: FormValues;
  errors?: Partial<Record<keyof FormValues, string>>;
  onValueChange: (field: keyof FormValues, value: string) => void;
}

const fieldInputClass =
  'h-8 rounded-none border-0 border-b border-gray-200 bg-transparent px-2 py-1 text-sm shadow-none focus-visible:ring-0 disabled:cursor-default disabled:opacity-100 disabled:text-black disabled:font-semibold';

const fieldRowClass = 'grid grid-cols-[160px_minmax(0,1fr)] items-center';

const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode, values, errors, onValueChange }) => {
  const isViewMode = formMode === 'view';
  const isCodeDisabled = isViewMode || formMode === 'edit';

  const renderError = (field: keyof FormValues) =>
    errors?.[field] ? <p className='mt-1 pl-40 text-xs text-red-600'>{errors[field]}</p> : null;

  return (
    <div className='space-y-2 px-4 py-5'>
      <div className='space-y-1'>
        <div>
          <div className={fieldRowClass}>
            <Label>Mã phương thức</Label>
            <Input
              value={values.ma_pttt}
              onChange={event => onValueChange('ma_pttt', event.target.value)}
              className={`${fieldInputClass} w-full max-w-64`}
              disabled={isCodeDisabled}
            />
          </div>
          {renderError('ma_pttt')}
        </div>

        <div>
          <div className={fieldRowClass}>
            <Label>Tên phương thức</Label>
            <Input
              value={values.ten_pttt}
              onChange={event => onValueChange('ten_pttt', event.target.value)}
              className={`${fieldInputClass} w-full max-w-96`}
              disabled={isViewMode}
            />
          </div>
          {renderError('ten_pttt')}
        </div>

        <div>
          <div className={fieldRowClass}>
            <Label>Tên khác</Label>
            <Input
              value={values.ten_pttt2 ?? ''}
              onChange={event => onValueChange('ten_pttt2', event.target.value)}
              className={`${fieldInputClass} w-full max-w-96`}
              disabled={isViewMode}
            />
          </div>
          {renderError('ten_pttt2')}
        </div>

        <div>
          <div className={fieldRowClass}>
            <Label>Mã pt.thức HĐĐT</Label>
            <Input
              value={values.ma_ph_thuc_hddt}
              onChange={event => onValueChange('ma_ph_thuc_hddt', event.target.value)}
              className={`${fieldInputClass} w-full max-w-64`}
              disabled={isViewMode}
            />
          </div>
          {renderError('ma_ph_thuc_hddt')}
        </div>

        <div>
          <div className={fieldRowClass}>
            <Label>Trạng thái</Label>
            <select
              value={values.status}
              onChange={event => onValueChange('status', event.target.value)}
              className={`${fieldInputClass} w-full max-w-64 cursor-default appearance-auto disabled:opacity-100`}
              disabled={isViewMode}
            >
              <option value='1'>1. Còn sử dụng</option>
              <option value='0'>0. Không sử dụng</option>
            </select>
          </div>
          {renderError('status')}
        </div>
      </div>
    </div>
  );
};

export default BasicInfoTab;
